(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('TabScheduleDetailController', TabScheduleDetailController);

    TabScheduleDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity'];

    function TabScheduleDetailController($scope, $rootScope, $stateParams, entity) {
        var vm = this;
        vm.tabSchedule = entity;

        var unsubscribe = $rootScope.$on('jotApp:tabScheduleUpdate', function(event, result) {
            vm.tabSchedule = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
